function setUpViewMoreRelatedWorks(
  location: string,
  breakpointsWithViewMoreBehavior: string[],
) {
  const RELATED_WORKS_GROUP_SIZE = 5;
  const BREAKPOINTS = {
    small: { max: 567 },
    medium: { min: 568, max: 1279 },
    large: { min: 1280 },
  };

  const relatedWorkSelector = `.js-safe-related-work-${location}`;
  const viewMoreButtonSelector = `.js-safe-related-works-${location}--view-more-button`;

  if (!document.querySelector(viewMoreButtonSelector)) return;

  const viewMoreButton: HTMLButtonElement | null = document.querySelector(
    viewMoreButtonSelector,
  );
  const getAllRelatedWorks = () =>
    document.querySelectorAll(relatedWorkSelector);

  let currentBreakpoint: string | null = null;

  const getCurrentBreakpoint = () => {
    const width = window.innerWidth;
    if (width < BREAKPOINTS.medium.min) return 'small';
    if (width < BREAKPOINTS.large.min) return 'medium';
    return 'large';
  };

  const handleViewMoreClick = () => {
    if (!viewMoreButton) return;
    const hiddenDivs = document.querySelectorAll(
      `${relatedWorkSelector}.hidden`,
    );

    Array.from(hiddenDivs)
      .slice(0, RELATED_WORKS_GROUP_SIZE)
      .forEach((div) => div.classList.remove('hidden'));

    if (hiddenDivs.length <= RELATED_WORKS_GROUP_SIZE) {
      viewMoreButton.style.display = 'none';
    }
  };

  const handleSetUpViewMoreBehavior = () => {
    if (!viewMoreButton) return;

    viewMoreButton.style.display = 'flex';

    const relatedWorks = getAllRelatedWorks();
    Array.from(relatedWorks)
      .slice(RELATED_WORKS_GROUP_SIZE)
      .forEach((div) => div.classList.add('hidden'));

    viewMoreButton.addEventListener('click', handleViewMoreClick);
  };

  const handleCleanUpViewMoreBehavior = () => {
    if (!viewMoreButton) return;
    getAllRelatedWorks().forEach((div) => div.classList.remove('hidden'));

    viewMoreButton.style.display = 'none';
  };

  const updateViewMoreBehavior = () => {
    const newBreakpoint = getCurrentBreakpoint();

    if (newBreakpoint !== currentBreakpoint) {
      currentBreakpoint = newBreakpoint;

      if (breakpointsWithViewMoreBehavior.includes(currentBreakpoint)) {
        handleSetUpViewMoreBehavior();
      } else {
        handleCleanUpViewMoreBehavior();
      }
    }
  };

  updateViewMoreBehavior();

  let resizeTimeout: NodeJS.Timeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateViewMoreBehavior, 250);
  });
}

export default setUpViewMoreRelatedWorks;
